import { inject } from "fw";
import { createFrom, createFromArray } from "fw-model";
import { Manager } from "./manager";
import { AppSyncDetail, AppSyncInfo, AppSyncSearchInfo, AppSyncSearchDetails } from "models/monitor-appsync-results";

@inject
export class AppsyncResultsRepository {
    constructor(private s: Manager) {}

    public async appSyncList(
        filter: string,
        search: string = null,
        orgFilter: string = null,
        sort: string = null,
        previousPageToken: string = null,
        nextPageToken: string = null,
        fieldsPaths: string = null,
        aggs: string = null,
        aggregationsOnly: boolean = false,
        pageSize: number = 20
    ): Promise<AppSyncSearchInfo> {
        const res = await this.s.get<AppSyncSearchInfo>("appsync/results", {
            filter,
            search,
            orgFilter,
            sort,
            pageSize,
            previousPageToken,
            nextPageToken,
            aggs,
            fieldsPaths,
            aggregationsOnly
        });
        return createFrom(AppSyncSearchInfo, res.body);
    }

    public async appSyncResultDetailsList(
        filter: string,
        search: string = null,
        orgFilter: string = null,
        sort: string = null,
        pageSize: number = 20,
        previousPageToken: string = null,
        nextPageToken: string = null,
        aggs: string = null,
        fieldsPaths: string = null
    ): Promise<AppSyncSearchDetails> {
        const res = await this.s.get<AppSyncSearchDetails>("appsync/result-details", {
            search,
            filter,
            orgFilter,
            sort,
            pageSize,
            aggs,
            previousPageToken,
            nextPageToken,
            fieldsPaths
        });
        return createFrom(AppSyncSearchDetails, res.body);
    }

    public async appSyncResultById(id: string): Promise<AppSyncInfo> {
        const res = await this.s.get<AppSyncInfo>(`appsync/results/${id}`);
        return createFrom(AppSyncInfo, res.body);
    }

    public async appSyncResultDetailsById(id: string): Promise<AppSyncDetail> {
        const res = await this.s.get<AppSyncDetail>(`appsync/result-details/${id}`);
        return createFrom(AppSyncDetail, res.body);
    }
}
